import styled from 'styled-components';
import theme from '../../theme';

export const Wrapper = styled.div`
	width: 100%;
	height: 70px;
	background-color: ${props => props.theme === 'light' ? theme.pink.dark : '#222222'};
	color: ${props => props.theme === 'light' ? 'white' : theme.pink.dark};
	display: flex;
	align-items: center;
	transition: 0.5s;
`;

export const Left = styled.div`
	margin: auto auto auto 5px;
	display: flex;
	flex-direction: row;
	align-items: center;
	color: ${props => props.theme === 'light' ? 'white' : theme.pink.dark};
	transition: 0.5s;
`;

export const Logo = styled.div`
	& > img {
		width: 60px;
		margin: 0 auto auto 10px;
		cursor: pointer;
    }
`;

export const HeaderText = styled.div`
	font-weight: bold;
	font-size: 1.2em;
	margin: 20px 10px;
	cursor: pointer;
`;

export const Right = styled.div`
	margin-left: auto;
	display: flex;
	align-items: center;

	& svg {
		transform: TranslateY(2px);
	}
`;

export const Signout = styled.div`
	margin-right: 20px;
	cursor: pointer;
	display: flex;
	color: ${props => props.theme === 'light' ? 'white' : theme.pink.dark};
	transition: 0.5s;
`;

export const SubHeaderText = styled.div`
	margin-right: 10px;
`;